import { useState, FormEvent, useEffect, useRef } from "react";
import { Button, Modal } from "react-bootstrap";
import { Form } from "react-bootstrap";
import "./simple-modal.scss";

export interface IPopupConfig {
  mode: string | JSX.Element;
  buttonText?: string;
  show: boolean;
  modalBody?: JSX.Element;
  saveButton?: JSX.Element;
  actionButtonDisabled?: boolean;
  extraButtons?: JSX.Element;
  wrapperClass?: string;
  validatedByParent?: boolean;
  handleModalClosed: () => void;
  handleSubmit: () => void;
  onModalClickHandler?: (event:React.MouseEvent<HTMLElement>) => void;
  showCancelButton?: boolean;
  allowScrollOnBody?: boolean;
  type?: "large" | "normal"
}

const SimpleModal = ({ type, mode,show, validatedByParent, saveButton, wrapperClass, onModalClickHandler, extraButtons, actionButtonDisabled, modalBody, handleSubmit, buttonText, handleModalClosed, showCancelButton, allowScrollOnBody=true }: IPopupConfig ) => {
  const [validated, setValidated] = useState(false);
  const modalRef = useRef<HTMLElement>(null);

  useEffect(() => {
    validatedByParent && setValidated(validatedByParent);
  }, [validatedByParent]);

  const handlerSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    event.stopPropagation();
    const form = event.currentTarget;
    if (form.checkValidity() !== true) {
      setValidated(true);
      return;
    }
    handleSubmit();
    setValidated(false);
  };

  return (
    <div className="popup simpleModal">
      <Modal onClick={onModalClickHandler && onModalClickHandler} ref={modalRef} className={`${wrapperClass? wrapperClass : ""}   simpleModalRef`} show={show} onHide={() => {setValidated(false); handleModalClosed();}}>
        <Form noValidate validated={validated} onSubmit={handlerSubmit} className={`${type === 'large' ? 'simpleModal-large' : ""}`}>
          <Modal.Header closeButton>
            <Modal.Title>{mode}</Modal.Title>
          </Modal.Header>
            <Modal.Body className={allowScrollOnBody ? "simpleModal-scrollable" : ""}>
            {modalBody}
            </Modal.Body>
          <Modal.Footer>
            {extraButtons && extraButtons}
            {showCancelButton && <Button  onClick={() => { setValidated(false); handleModalClosed(); }}>
              Close
            </Button>}
            {saveButton? saveButton : <Button disabled={actionButtonDisabled && true} className="popup-action" type="submit" variant="primary">
              {buttonText}
            </Button>}
          </Modal.Footer>
        </Form>
      </Modal>
    </div>
  );
};

export default SimpleModal;